import React from 'react';
import './Marquee.css';

const ITEMS = [
  '🍛 Wedding Catering',
  '🌿 Fresh Daily Masalas',
  '🍃 Banana Leaf Service',
  '🔥 Wood-Fire Cooking',
  '💍 Corporate Events',
  '🎂 Birthday Parties',
  '🙏 Religious Functions',
  '⭐ Authentic Since 1998',
  '🍚 Chettinad Biryani',
  '📍 Sevvur,Sivagangai,Tamil Nadu',
];

function Marquee() {
  return (
    <div className="marquee-strip">
      <div className="marquee-track">
        {[...ITEMS, ...ITEMS].map((item, i) => (
          <span key={i} className="marquee-item">
            {item}
            <span className="marquee-dot">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}

export default Marquee;